import fetcher from './fetcher';

export function saveHRVData(resonatorId, HRVData) {
    return fetcher.post(`/hrv/save`, {resonatorId, HRVData});
}
